import React, { useState } from 'react';
import { Button, Card, Col, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DrugListTable from './DrugListTable';
import DrugListModal from './DrugListModal';
import CommonBreadCrumb from 'components/commonbreadcrumb/CommonBreadCrumb';

const DrugList = () => {
    const [trigger, setTrigger] = useState(0);
    const [edittrigger, setEditTrigger] = useState(0);
    const [druglistval, setDrugListVal] = useState('');
    const [showModal, setShowModal] = useState(false);

    const callAnotherChildMethod = () => {
        setTrigger((trigger) => trigger + 1);
    };

    const callAnotherEditChildMethod = (editValue) => {
        setDrugListVal(editValue);
        setEditTrigger((edittrigger) => edittrigger + 1);
        setShowModal(true);
    };

    const handleOpenAddModal = () => {
        setDrugListVal('');
        setEditTrigger(0);
        setShowModal(true);
    };

    const breadcrumbItems = [
        { name: 'Dashboard', href: '/main', isActive: false },
        { name: 'Drug-List', href: '', isActive: true }
    ];

    return (
        <>
            <CommonBreadCrumb breadcrumbItems={breadcrumbItems} />
            <Row className="g-3 mt-1">
                <Col xs={12}>
                    <Card>
                        <Card.Header className="bg-body-tertiary py-2">
                            <h5 className="mb-0">Drug List</h5>
                        </Card.Header>
                        <Card.Body>
                            <DrugListTable
                                trigger={trigger}
                                onCallEditParent={callAnotherEditChildMethod}
                                onOpenAddModal={handleOpenAddModal}
                            />
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <DrugListModal
                show={showModal}
                onHide={() => setShowModal(false)}
                druglistvalue={druglistval}
                edittrigger={edittrigger}
                onCallParent={callAnotherChildMethod}
            />
        </>
    );
};

export default DrugList;

